/* eslint-disable react/no-danger */
import React from 'react'

const appId = process.env.INTERCOM_APP_ID

export const IntercomScript = () => {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.intercomSettings = {
              app_id: "${appId}",
            };
          `,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
          (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${appId}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
          `,
        }}
      />
    </>
  )
}

export const withIntercom = (Page) => {
  class WithIntercom extends React.Component {
    static displayName = `withIntercom(${Page.displayName || Page.name || 'Page'})`

    static async getInitialProps(props) {
      let initialProps = {}
      if (Page.getInitialProps) {
        initialProps = await Page.getInitialProps(props)
      }

      return {
        ...initialProps,
      }
    }

    render() {
      const { ...pageProps } = this.props
      return (
        <>
          <Page {...pageProps} />
          <IntercomScript />
        </>
      )
    }
  }
  return WithIntercom
}
